import type { stacks } from "@dropbox/api-v2-client";
import { UIIcon } from "@dropbox/dig-icons";
import { LinkLine } from "@dropbox/dig-icons/assets";
import { createUxaElementId } from "@mirage/analytics/uxa";
import { IconButtonWithTooltip } from "@mirage/shared/icons/IconButtonWithTooltip";
import { useCopyStackUrlToClipboard } from "@mirage/stacks/CopyStackUrl";
import i18n from "@mirage/translations";

interface CopyLinkStackButtonProps {
  stack: stacks.Stack | null;
}

export const CopyLinkStackButton: React.FC<CopyLinkStackButtonProps> = ({
  stack,
}) => {
  const copyLink = useCopyStackUrlToClipboard(stack);
  return (
    <IconButtonWithTooltip
      tooltipProps={{
        title: i18n.t("copy_link"),
      }}
      variant="transparent"
      onClick={copyLink}
      data-testid="CopyLinkStack"
      aria-label={i18n.t("copy_link")}
      data-uxa-log={createUxaElementId("copy_link_button", {
        actionSurfaceComponent: "stacks",
        featureLine: "stacks",
      })}
      data-uxa-entity-id={stack?.namespace_id ?? ""}
    >
      <UIIcon src={LinkLine} />
    </IconButtonWithTooltip>
  );
};
